/**
 * Swiper
 * Created by zdy on 2018/12/05.
 */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
    View,
    FlatList,
    Animated,
    Platform,
    TouchableOpacity
} from 'react-native';

import {
    JDDevice
} from '@jdreact/jdreact-core-lib';

import { pt } from '../../../common/utils';

import st from './style';

class Swiper extends PureComponent {
    constructor(props) {
        super(props);
        this.refUnits = [];
        this.refScrollView = null;
        this.shouldGo = 0;
        this.timeout = null;
        this.preventSecondEvent = false;
        this.offset = 0;
        this.times = 0;
        this.endTimes = 0;
    }

    render() {
        const { data, renderItem, unitWidth, unitHeight, wrapWidth, style } = this.props;

        const padding = JDDevice.width / 2 - wrapWidth / 2;

        return (
            <View style={ [st.container, style] }>
                <FlatList
                    ref={ e => { this.refScrollView = e; } }
                    initialNumToRender={ data.length }
                    scrollEventThrottle={ 16 }
                    onScroll={ this.onScroll }
                    onScrollBeginDrag={ this.onScrollBeginDrag }
                    onScrollEndDrag={ this.onScrollEndDrag }
                    onTouchStart={ this.onTouchStart }
                    // onTouchEnd={this.onTouchEnd}
                    onMomentumScrollEnd={ this.onMomentumScrollEnd }
                    // contentContainerStyle={{ paddingHorizontal: JDDevice.width / 2 - wrapWidth / 2 }}
                    horizontal={ true }
                    bounces={ false }
                    showsHorizontalScrollIndicator={ false }
                    data={ data }
                    keyExtractor={ (item, index) => index + '' }
                    ListHeaderComponent={ () =>
                        <View style={ { width: padding } } />
                    }
                    ListFooterComponent={ () =>
                        <View style={ { width: padding } } />
                    }
                    renderItem={ ({ item, index }) => {
                        return (
                            <View style={ [st.unit_wrap, { width: wrapWidth }] }>
                                <TouchableOpacity
                                    activeOpacity={ 0.5 }
                                    onPress={ () => this.onPress(item, index) }
                                >
                                    <Animated.View
                                        ref={ e => { this.refUnits[index] = e; } }
                                        style={ [st.pic_wrap, { width: unitWidth, height: unitHeight }] }
                                    >
                                        {renderItem(item, index)}
                                    </Animated.View>
                                </TouchableOpacity>
                            </View>
                        );
                    } }
                />
            </View>
        );
    }

    componentDidMount() {
        const { maxWidth, maxHeight, wrapWidth } = this.props;

        const element = this.refUnits[this.props.listIndex];

        element && element.setNativeProps({
            style: {
                width: maxWidth,
                height: maxHeight
            }
        });
        this.shouldGo = this.props.listIndex;
        setTimeout(() => {
            this.refScrollView && this.refScrollView.scrollToOffset({ offset: wrapWidth * this.props.listIndex, animated: true });
        }, 10);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.data !== this.props.data) {
            const movieId = this.props.data[this.shouldGo].movieId;

            let index = nextProps.data.findIndex(x => x.movieId === movieId);

            index < 0 && (index = 0);
            const { maxWidth, maxHeight, wrapWidth } = this.props;

            const element = this.refUnits[index];

            element && element.setNativeProps({
                style: {
                    width: maxWidth,
                    height: maxHeight
                }
            });

            setTimeout(() => {
                this.refScrollView && this.refScrollView.scrollToOffset({ offset: wrapWidth * index, animated: true });
            }, 10);
        }
    }

    onPress = (item, index) => {
        this.preventSecondEvent = true;
        const { onPress } = this.props;

        this.shouldGo = index;
        this.scrollTo();
        onPress && onPress(item, index);
    }

    onTouchStart = (e) => {
        if (Platform.OS !== 'web') return;
        this.preventSecondEvent = false;
        this.times++;
    }

    onScrollBeginDrag = (e) => {
        this.preventSecondEvent = false;
        this.times++;
    }

    onScroll = (e) => {
        const { wrapWidth, data } = this.props;

        const offset = e.nativeEvent.contentOffset.x;

        const pos = offset / wrapWidth;

        let index = Math.round(pos);

        const maxIndex = data.length - 1;

        index <= 0 && (index = 0);
        index > maxIndex && (index = maxIndex);
        this.transform(index, pos);
        this.cancel();
        this.shouldGo = index;
        this.offset = offset;
        this.timeout = setTimeout(() => {
            this.active();
        }, 300);
    }

    onScrollEndDrag = (e) => {
        if (Platform.OS === 'android') return;
        const { wrapWidth, data } = this.props;

        const offset = e.nativeEvent.contentOffset.x;

        const pos = offset / wrapWidth;

        let index = Math.round(pos);

        const maxIndex = data.length - 1;

        index <= 0 && (index = 0);
        index > maxIndex && (index = maxIndex);
        this.shouldGo = index;
        this.offset = offset;
        this.timeout = setTimeout(() => {
            this.active();
        }, 50);
    }

    onTouchEnd = (e) => {
        if (Platform.OS !== 'web') return;
        const { wrapWidth, data } = this.props;

        const offset = e.nativeEvent.contentOffset.x;

        const pos = offset / wrapWidth;

        let index = Math.round(pos);

        const maxIndex = data.length - 1;

        index <= 0 && (index = 0);
        index > maxIndex && (index = maxIndex);
        this.shouldGo = index;
        this.offset = offset;
        console.log(offset, index);
        // this.timeout = setTimeout(() => {
        this.active();
        // }, 50);
    }

    onMomentumScrollEnd = (e) => {
        if (this.isSpecialModel) return;
        const { wrapWidth, data } = this.props;

        const offset = e.nativeEvent.contentOffset.x;

        const pos = offset / wrapWidth;

        let index = Math.round(pos);

        const maxIndex = data.length - 1;
        // 处理快速滑动结束不允许回弹
        // index - this.shouldGo > 0 && pos > index && index++;
        // index - this.shouldGo < 0 && pos < index && index--;

        index <= 0 && (index = 0);
        index > maxIndex && (index = maxIndex);
        this.shouldGo = index;
        if (this.times !== this.endTimes) {
            this.active();
            this.endTimes = this.times;
        }
    }

    scrollTo() {
        const { wrapWidth } = this.props;

        const offset = wrapWidth * this.shouldGo;

        if (this.offset && Math.abs(this.offset, offset) < 1) return;
        this.refScrollView.resetScrollResponder && this.refScrollView.resetScrollResponder();
        this.refScrollView && this.refScrollView.scrollToOffset({ offset, animated: true });
    }

    active() {
        this.scrollTo();
        // 滑动结束回调
        if (this.preventSecondEvent) return;
        this.preventSecondEvent = true;
        const { onScrollEnd, data } = this.props;

        const index = this.shouldGo;

        onScrollEnd && onScrollEnd(data[index], index);
        this.timeout = null;
    }

    cancel() {
        if (this.timeout) {
            clearTimeout(this.timeout);
            this.timeout = null;
        }
    }

    transform(index, pos = index) {
        const { unitWidth, unitHeight, maxWidth, maxHeight } = this.props;

        const maxScaleX = maxWidth / unitWidth;

        const maxScaleY = maxHeight / unitHeight;

        for (let i = index + 3; i >= index - 3; i--) {
            const element = this.refUnits[i];

            let scaleX = maxScaleX - (maxScaleX - 1) * Math.abs(pos - i);

            let scaleY = maxScaleY - (maxScaleY - 1) * Math.abs(pos - i);

            scaleX < 1 && (scaleX = 1);
            scaleY < 1 && (scaleY = 1);
            element && element.setNativeProps({
                style: {
                    width: unitWidth * scaleX,
                    height: unitHeight * scaleY
                }
            });
        }
    }
}

Swiper.defaultProps = {
    // 正常宽度
    unitWidth: pt(65),
    // 正常高度
    unitHeight: pt(88),
    // 最大宽度
    maxWidth: pt(86),
    // 最大高度
    maxHeight: pt(124),
    // 容器宽度
    wrapWidth: pt(90)
};

Swiper.propTypes = {
    // 数据对象
    data: PropTypes.array.isRequired,
    // 正常宽度
    unitWidth: PropTypes.number,
    // 正常高度
    unitHeight: PropTypes.number,
    // 最大宽度
    maxWidth: PropTypes.number,
    // 最大高度
    maxHeight: PropTypes.number,
    // 容器宽度
    wrapWidth: PropTypes.number,
    // 渲染元素
    renderItem: PropTypes.func.isRequired,
    // 点击事件
    onPress: PropTypes.func,
    // 滑动结束
    onScrollEnd: PropTypes.func,
    // 允许自定义style
    style: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.object,
        PropTypes.array
    ])
};

export default Swiper;
